import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IBooking, ISchedule, ITableLayout } from "app/app.types";
import moment from "moment-timezone";

const initialState: VenueState = {
  openVenueListDrawer: false,
  selectedVenue: { id: 0, name: '', isPosActive: false, timeZoneId: moment.tz.guess() },
  venues: [] as IVenue[],
  filteredBookingList: [] as IBooking[],
  bookingsByDateForServiceGroupingPaxGrouping: [] as IVenueBookings[],
  tablesLayoutsForTheDay: [] as IVenueTablesLayoutsForTheDay[],
  scheduleDetailsByTheDate: [] as IVenueScheduleDetailsByTheDate[]
}

export interface IVenueBookings
{
  venueId: number,
  bookings: IBooking[],
}

export interface IVenueTablesLayoutsForTheDay {
  venueId: number,
  tablesLayoutsForTheDay: ITableLayout[]
}

export interface IVenueScheduleDetailsByTheDate {
  venueId: number,
  scheduleDetailsByTheDate: ISchedule
}

export interface IVenue {
  id: number,
  name: string,
  isPosActive: boolean,
  timeZoneId: string
}

export interface VenueState {
  selectedVenue: IVenue,
  openVenueListDrawer: boolean
  venues: IVenue[],
  filteredBookingList: IBooking[];
  bookingsByDateForServiceGroupingPaxGrouping: IVenueBookings[];
  tablesLayoutsForTheDay: IVenueTablesLayoutsForTheDay[];
  scheduleDetailsByTheDate: IVenueScheduleDetailsByTheDate[];
}

export const venueSlice = createSlice({
  name: 'VenueSelect',
  initialState,
  reducers: {
    setVenues: (state, action: PayloadAction<IVenue[]>) => {
      return {
        ...state,
        venues: action.payload
      };
    },
    handleOpenVenueListDrawer: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        openVenueListDrawer: action.payload
      };
    },
    setSelectedVenue: (state, action: PayloadAction<IVenue>) => {
      window.localStorage.setItem('selectedVenue', JSON.stringify(action.payload));
      return {
        ...state,
        selectedVenue: action.payload
      };
    },
    resetSelectedVenue: (state, action: PayloadAction) => {
      window.localStorage.removeItem('selectedVenue');
      return {
        ...state,
        selectedVenue: { id: 0, name: '' } as IVenue
      };
    },
    saveFilteredBookings: (state, action: PayloadAction<IBooking[]>) => {
      return {
        ...state,
        filteredBookingList: action.payload || []
      };
    },
    saveBookingsByTheDate: (state, action: PayloadAction<IVenueBookings[]>) => {
      return {
        ...state,
        bookingsByDateForServiceGroupingPaxGrouping: action.payload || []
      };
    },
    saveTablesByTheDate: (state, action: PayloadAction<IVenueTablesLayoutsForTheDay[]>) => {
      return {
        ...state,
        tablesLayoutsForTheDay: action.payload || []
      };
    },
    saveScheduleByTheDate: (state, action: PayloadAction<IVenueScheduleDetailsByTheDate[]>) => {
      return {
        ...state,
        scheduleDetailsByTheDate: action.payload || []
      };
    }
  }
});

export const { setSelectedVenue, 
  resetSelectedVenue, 
  handleOpenVenueListDrawer, 
  setVenues, 
  saveFilteredBookings, 
  saveBookingsByTheDate, 
  saveTablesByTheDate,
  saveScheduleByTheDate 
} = venueSlice.actions;

export default venueSlice.reducer;